import React, { useState, useEffect } from "react";
import { CopyBlock, dracula, CodeBlock, atomOneLight } from "react-code-blocks";
import PropTypes from "prop-types";

const LANG = {
  CURL: "CURL",
  NODEJS: "NodeJS",
  PHP: "PHP",
};

const ButtonLanguage = ({ lang, onChange }) => {
  return (
    <div className="btn-group snippet-btn-container" role="group" aria-label="Basic example">
      <button
        type="button"
        className={`btn snippet snippet-btn ${lang === LANG.CURL && "active"}`}
        onClick={() => onChange(LANG.CURL)}
      >
        CURL
      </button>
      <button
        type="button"
        className={`btn snippet snippet-btn ${lang === LANG.NODEJS && "active"}`}
        onClick={() => onChange(LANG.NODEJS)}
      >
        NodeJS
      </button>
      <button
        type="button"
        className={`btn snippet snippet-btn ${lang === LANG.PHP && "active"}`}
        onClick={() => onChange(LANG.PHP)}
      >
        PHP
      </button>
    </div>
  );
};

ButtonLanguage.propTypes = {
  lang: PropTypes.string,
  onChange: PropTypes.func,
};

ButtonLanguage.defaultProps = {
  lang: LANG.CURL,
  onChange: () => ({}),
};

const CodeSnippet = ({ listReqRes, className }) => {
  const showLineNumbers = true;
  const [selectedLanguage, setLanguage] = useState(LANG.CURL);
  const [selectedRequest, setRequest] = useState("");
  const [selectedResponse, setResponse] = useState("");

  useEffect(() => {
    const selectedCode = listReqRes.find((item) => item.language === selectedLanguage);
    setRequest(selectedCode.request);
    setResponse(selectedCode.response);
  }, [selectedLanguage]);

  // eslint-disable-next-line consistent-return
  const resolveLanguage = (lang) => {
    switch (lang) {
      case LANG.CURL:
        return "json";
      case LANG.NODEJS:
        return "javascript";
      case LANG.PHP:
        return "php";
      default:
        break;
    }
  };

  return (
    <div className={className}>
      <div className="snippet snippet-dark half-height">
        <ButtonLanguage lang={selectedLanguage} onChange={(value) => setLanguage(value)} />
        <CopyBlock
          text={selectedRequest}
          language={resolveLanguage(selectedLanguage)}
          showLineNumbers={showLineNumbers}
          theme={dracula}
          codeBlock
        />
      </div>
      <div className="snippet snippet-light-title">RESPONSE</div>
      <div className="snippet snippet-light half-height">
        <CodeBlock
          text={selectedResponse}
          language="json"
          showLineNumbers={!showLineNumbers}
          theme={atomOneLight}
        />
      </div>
    </div>
  );
};

CodeSnippet.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  listReqRes: PropTypes.array,
  className: PropTypes.string,
};

CodeSnippet.defaultProps = {
  listReqRes: [],
  className: "",
};

export default CodeSnippet;
